import Layout from '@/container/Full'
const WebsitesListView = () => import(/* webpackChunkName: "websites" */ '../views/websites/WebsitesListView.vue')

const routes = [
  {
    path: '/websites',
    component: Layout,
    children: [
      {
        path: '',
        name: 'websites-list',
        component: WebsitesListView,
        meta: {
          breadcrumb: 'My Hosting Accounts',
          pageTitle: 'My Hosting Accounts',
          access_type: 'authorized'
        },
        children: []
      },
    ],
  }
]

export default routes
